import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AdminSellerService, SellerDetails } from '../../../_services/admin-seller.service';

@Component({
    selector: 'app-seller-details',
    templateUrl: './seller-details.component.html',
    styleUrls: ['./seller-details.component.css'],
    standalone: false
})
export class SellerDetailsComponent implements OnInit, OnDestroy {
    sellerId: string = '';
    seller: SellerDetails | null = null;
    loading = false;
    private modalRef: NgbModalRef;

    constructor(
        private adminSellerService: AdminSellerService,
        private route: ActivatedRoute,
        private router: Router,
        private titleService: Title,
        private modalService: NgbModal,
        private toastr: ToastrService
    ) {
        this.titleService.setTitle('Seller Details');
    }

    ngOnInit(): void {
        this.sellerId = this.route.snapshot.params['sellerId'];
        if (this.sellerId) {
            this.loadSellerDetails();
        }
    }

    ngOnDestroy(): void {
        this.titleService.setTitle('');
        if (this.modalRef) {
            this.modalRef.close();
        }
    }

    loadSellerDetails(): void {
        this.loading = true;
        this.adminSellerService.getSellerDetails(this.sellerId).subscribe({
            next: (response) => {
                this.seller = response.data;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
                this.toastr.error('Error loading seller details');
            }
        });
    }

    isCompanySeller(): boolean {
        return this.seller?.sellerType === 'company';
    }

    isPrivateSeller(): boolean {
        return this.seller?.sellerType === 'private';
    }

    canApprove(): boolean {
        return this.seller?.status === 'COMPLETED' || this.seller?.status === 'REJECTED';
    }

    canReject(): boolean {
        return this.seller?.status === 'COMPLETED' || this.seller?.status === 'VERIFIED';
    }

    openApproveConfirmation(confirmModal: TemplateRef<any>): void {
        this.modalRef = this.modalService.open(confirmModal, { centered: true });
    }

    confirmApprove(): void {
        if (this.modalRef) {
            this.modalRef.close();
        }
        
        this.adminSellerService.approveSeller(this.sellerId).subscribe({
            next: () => {
                this.toastr.success('Seller approved successfully');
                this.router.navigate(['/admin', 'sellers']);
            },
            error: () => {
                this.toastr.error('Error approving seller');
            }
        });
    }

    openRejectModal(): void {
        this.router.navigate(['/admin', 'sellers', this.sellerId, 'reject']);
    }

    goBack(): void {
        this.router.navigate(['/admin', 'sellers']);
    }

    getStatusClass(): string {
        switch (this.seller?.status) {
            case 'PENDING':
                return 'badge bg-warning';
            case 'COMPLETED':
                return 'badge bg-info';
            case 'VERIFIED':
                return 'badge bg-success';
            case 'REJECTED':
                return 'badge bg-danger';
            default:
                return 'badge bg-secondary';
        }
    }
}
